import { useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

export const Tooltip = ({ title, children, html }: any) => {
  const { t } = useTranslation()
  const triggerRef = useRef<HTMLDivElement>(null)
  const [visible, setVisible] = useState(false)
  const [pos, setPos] = useState({ top: 0, left: 0 })

  const show = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect()
      setPos({
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX
      })
    }
    setVisible(true)
  }

  const hide = () => setVisible(false)

  return (
    <div
      ref={triggerRef}
      className='inline-flex'
      onMouseEnter={show}
      onMouseLeave={hide}
    >
      {children}
      {visible &&
        createPortal(
          <div
            className='absolute max-w-xs z-[9999] pointer-events-none'
            style={{
              top: pos.top,
              left: pos.left,
              transform: 'translateY(-100%)'
            }}
          >
            <div className='pb-2'>
              <div className='p-2 bg-gray-900 text-white text-xs rounded shadow-lg [&_a]:text-blue-400 [&_a]:underline [&_a:hover]:text-blue-300'>
                {typeof title === 'string' ?
                  html ?
                    <span dangerouslySetInnerHTML={{ __html: t(title) }} />
                  : t(title)
                : title}
                <div className='absolute left-2 top-full -mt-2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-900'></div>
              </div>
            </div>
          </div>,
          document.body
        )}
    </div>
  )
}
